/**
 * Strips USB vendor/product IDs from device labels while preserving "(Built-in)" suffix.
 * Examples:
 * - "FaceTime HD Camera (Built-in) (05ac:8514)" -> "FaceTime HD Camera (Built-in)"
 * - "NexiGo HD (oc45:3212)" -> "NexiGo HD"
 */
export const cleanDeviceLabel = (label: string): string => {
    return label.replace(/\s*\([0-9a-f]{4}:[0-9a-f]{4}\)\s*$/i, '').trim();
};
